/* eslint-disable */
import React, { Component } from 'react'
import './styles.css';
import PropTypes from 'prop-types';

import Config from '../../config/app';
import { Editor } from '@tinymce/tinymce-react';

const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
class HTML extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value ? this.props.value : ''
    }
  }

  onEditorStateChange = (e) => {
    // this.setState({ value: e.target.getContent() });
    this.props.updateAction(this.props.theKey, e.target.getContent());

  }

  render() {
    var value = this.props.value;
    // this.editor.editor.setContent(value);
    return (
      <div className={Config.designSettings.editElementDivClass}>
        <label className="control-label"></label>
        <Editor
          apiKey={"qcweearl49864qamr6avj61zl9g679ha0aqljy9nxi6cre8v"}
          value={value}
          init={{
            selector: "textarea",  // change this value according to your html
            plugins: 'link image lists textcolor ',
            menubar: false,

            statusbar: false,
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify|formatselect| bullist numlist |image|lists',

            setup: function (ed) {
              ed.on('init', function () {
                this.execCommand("fontName", false, "Roboto");
                this.execCommand("fontSize", false, "15px");
              });
            }
          }}
          onEditorChange={(content, editor) => {
            this.props.updateAction(content);
          }}
        // onChange={this.onEditorStateChange}
        />
      </div>
    )
  }
}
export default HTML;

HTML.propTypes = {
  updateAction: PropTypes.func.isRequired,
  theKey: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  class: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/fields/HTML_forspeaker.js